import { ACCOUNT_BRAND_ID } from 'documents-ui/constants/BrandConstants';
export const getBrandId = searchResult => {
  const description = searchResult.description;
  if (!description) {
    return String(ACCOUNT_BRAND_ID);
  }
  try {
    const {
      brandId
    } = JSON.parse(description);
    return brandId != null ? String(brandId) : String(ACCOUNT_BRAND_ID);
  } catch (_unused) {
    return String(ACCOUNT_BRAND_ID);
  }
};